import { gql } from "@apollo/client";

// What happened in a user's account, and which of it an admin did while
// signed in as the user (DEV-1187).

export const GET_USER_ACTIVITY_LOG = gql`
  query userActivityLog($userId: Int!, $limit: Int, $onlyAdmins: Boolean) {
    userActivityLog(userId: $userId, limit: $limit, onlyAdmins: $onlyAdmins) {
      id
      actorName
      actorEmail
      entityType
      action
      entityId
      changes {
        subject
        detail
      }
      bySupport
      impersonatorEmail
      createdAt
    }
  }
`;

export const GET_IMPERSONATION_SESSIONS = gql`
  query impersonationSessions($userId: Int, $limit: Int) {
    impersonationSessions(userId: $userId, limit: $limit) {
      id
      adminEmail
      ip
      userAgent
      startedAt
      expiresAt
      endedAt
    }
  }
`;

export const GET_AUDIT_LOG = gql`
  query auditLog($sessionId: String, $limit: Int) {
    auditLog(sessionId: $sessionId, limit: $limit) {
      id
      operation
      args
      success
      error
      createdAt
    }
  }
`;
